import React from 'react';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { GroupModalActions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import GroupAddEdit from './GroupModalComponents/GroupAddEdit';
import ViewGroupScheduleCall from './GroupModalComponents/ViewGroupScheduleCall';
import GroupDeleteConfirmModal from './GroupDeleteConfirmModal';
import AddMembers from './GroupModalComponents/AddMembers';
import AddEditCall from './GroupModalComponents/AddEditCall';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import RemoveMemberConfirmModal from './RemoveMemberConfirmModal';
import GroupCallDeleteConfirmModal from './GroupCallDeleteConfirmModal';

dayjs.extend(timezone);

const LocalTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const GroupsModal = ({
  showGroupModal,
  closeGroupModal,
  groupModalAction,
  groupDeleteAction,
  showGroupDeleteConfirmModal,
  closeGroupDeleteConfirmModal,
  record,
  onActionClick,
  setRefreshGroupList,
  userHubsData = [], // Added userHubsData prop
  staffListData = [], // Added staffListData prop
  onMembersAdd, // Added callback for when members are added
  userInfo,
  timeZone,
  setGroupName,
  showRemoveMemberConfirmModal,
  closeRemoveMemberConfirmModal,
  scheduleModalData,
  groupName,
  setEditScheduleData,
  editScheduleData,
  onGroupModalActionClick,
  setRefreshSchedulePage,
  isStaffAdmin,
  removeMemberUuid,
  removeMemberName,
  setLatestGroupInfo,
  showGroupCallDeleteConfirmModal,
  closeGroupCallDeleteConfirmModal,
  groupCallDeleteShowHandler,
  setDeleteScheduleCallObj,
  deleteScheduleCallObj,
  setGroupModalAction,
  setShowRemoveMemberConfirmModal,
  isStaff,
  loginUserTimeformat,
}) => {
  const trans = useSelector(translator);

  const userTimezone = timeZone || LocalTimezone;

  const closeGroupModalHandler = () => {
    closeGroupModal();
    setGroupModalAction(null);
    setShowRemoveMemberConfirmModal(false);
  };

  // Handle members addition
  const handleMembersAdd = (membersData) => {
    if (onMembersAdd) {
      onMembersAdd(membersData);
    }
    // Optionally refresh the group list
    if (setRefreshGroupList) {
      setRefreshGroupList((prev) => !prev);
    }
  };

  const renderModalContent = () => {
    switch (groupModalAction) {
      case GroupModalActions.addGroup:
      case GroupModalActions.editGroup:
        return (
          <GroupAddEdit
            closeGroupModal={closeGroupModal}
            groupModalAction={groupModalAction}
            groupDeleteAction={groupDeleteAction}
            record={record}
            setRefreshGroupList={setRefreshGroupList}
            setGroupName={setGroupName}
            closeGroupModalHandler={closeGroupModalHandler}
          />
        );

      case GroupModalActions.viewScheduleCall:
        return (
          <ViewGroupScheduleCall
            closeGroupModal={closeGroupModal}
            setRefreshGroupList={setRefreshGroupList}
            scheduleModalData={scheduleModalData}
            groupName={groupName}
            setEditScheduleData={setEditScheduleData}
            onGroupModalActionClick={onGroupModalActionClick}
            isStaffAdmin={isStaffAdmin}
            userInfo={userInfo}
            userTimezone={userTimezone}
            isStaff={isStaff}
            closeGroupModalHandler={closeGroupModalHandler}
          />
        );

      case GroupModalActions.addMember:
        return (
          <AddMembers
            closeGroupModal={closeGroupModal}
            groupModalAction={groupModalAction}
            setRefreshGroupList={setRefreshGroupList}
            userHubsData={userHubsData}
            staffListData={staffListData}
            onMembersAdd={handleMembersAdd}
            closeGroupModalHandler={closeGroupModalHandler}
          />
        );

      case GroupModalActions.createScheduleCall:
      case GroupModalActions.editScheduleCall:
        return (
          <AddEditCall
            closeGroupModal={closeGroupModal}
            groupModalAction={groupModalAction}
            userTimezone={userTimezone}
            reFetchList
            eventRecord={editScheduleData}
            userInfo={userInfo}
            record={record}
            setRefreshSchedulePage={setRefreshSchedulePage}
            groupCallDeleteShowHandler={groupCallDeleteShowHandler}
            setDeleteScheduleCallObj={setDeleteScheduleCallObj}
            closeGroupModalHandler={closeGroupModalHandler}
            isStaffAdmin={isStaffAdmin}
            isStaff={isStaff}
            loginUserTimeformat={loginUserTimeformat}
            setLatestGroupInfo={setLatestGroupInfo}
          />
        );

      default:
        return <div>{trans('NOMODALACTIONRENDERED')}</div>;
    }
  };

  return (
    <>
      <Modal
        open={showGroupModal}
        onOk={closeGroupModalHandler}
        onCancel={closeGroupModalHandler}
        footer={null}
        closable={false}
        centered
        className="group-modal-container"
        tabIndex={-1}
        style={{
          borderRadius: '8px',
        }}
        styles={{
          body: {
            padding: 0,
            borderRadius: '8px',
          },
        }}
      >
        {renderModalContent()}
      </Modal>

      {groupModalAction === GroupModalActions.editGroup && (
        <GroupDeleteConfirmModal
          showGroupDeleteConfirmModal={showGroupDeleteConfirmModal}
          closeGroupDeleteConfirmModal={closeGroupDeleteConfirmModal}
          record={record}
          onActionClick={onActionClick}
          setRefreshGroupList={setRefreshGroupList}
          closeGroupModal={closeGroupModal}
        />
      )}
      {groupModalAction === GroupModalActions.editScheduleCall && (
        <GroupCallDeleteConfirmModal
          showGroupCallDeleteConfirmModal={showGroupCallDeleteConfirmModal}
          closeGroupCallDeleteConfirmModal={closeGroupCallDeleteConfirmModal}
          setRefreshSchedulePage={setRefreshSchedulePage}
          closeGroupModal={closeGroupModal}
          deleteScheduleCallObj={deleteScheduleCallObj}
        />
      )}
      {groupModalAction === null && (
        <RemoveMemberConfirmModal
          showRemoveMemberConfirmModal={showRemoveMemberConfirmModal}
          closeRemoveMemberConfirmModal={closeRemoveMemberConfirmModal}
          record={record}
          onActionClick={onActionClick}
          setRefreshGroupList={setRefreshGroupList}
          removeMemberUuid={removeMemberUuid}
          groupName={groupName}
          removeMemberName={removeMemberName}
          setLatestGroupInfo={setLatestGroupInfo}
        />
      )}
    </>
  );
};

export default GroupsModal;
